import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'cooperate-information',
  templateUrl: './index.component.html',
  styleUrls: ['./index.component.less'],
})
export class CooperateInformation implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
